var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":"","disabled":!_vm.tooltip},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"color":_vm.chipColor,"small":_vm.small}},on),[_vm._v(" "+_vm._s(_vm.statusToText())+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.statusToTooltip()))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }